// ENUMS ##############################################################
export enum DownloadFormatEnum {
	CSV = 'csv',
	JSON = 'json',
	KEY = 'key',
	TXT = 'txt',
}
